import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';

import { Markdown } from '~components/Markdown';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockImportant.module.scss';
import { ContentBlockImportantProps } from './ContentBlockImportant.types';

export function ContentBlockImportant({
  text,
  ...sectionProps
}: ContentBlockImportantProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <article
        className={styles.container}
        data-testid="content-block-important_description"
      >
        <Typography
          className={styles.description}
          tagName={TypographySizes.div}
          mods={[TypographyMods.titleS]}
        >
          Важно знать
        </Typography>
        <Markdown markdownString={text} />
      </article>
    </ContentBlockWrapper>
  );
}
